<template>
  <div>
    <v-card flat class="ma-2 pa-2 card-rounded">
      <v-card-title>
        <h3 class="primary--text">Locais de trabalho</h3>
      </v-card-title>
      <v-divider />
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="[...headers, { text: $t('common.Edit'), value: 'edit' }]"
        :items="workplaces || []"
        :pagination.sync="pagination"
        select-all
        item-key="_id"
        class="elevation-1 text-truncate"
      >
        <template v-slot:headers="props">
          <tr>
            <th>
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"
              />
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : ''
              ]"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected">
            <td>
              <v-checkbox v-model="props.selected" primary hide-details />
            </td>
            <td
              class="text-xs-center"
              @click="editWorkplaces(props)"
              v-for="header in headers"
              :key="header.value"
            >
              {{ props.item[header.value] }}
            </td>
            <td style="text-align: center">
              <v-btn icon @click.stop="editWorkplaces(props)">
                <v-icon small>edit</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <SlotDial>
      <v-btn fab dark small color="indigo" @click="dialog = true">
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn fab dark small color="error" @click="deleteEntries">
        <v-icon>delete</v-icon>
      </v-btn>
    </SlotDial>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600"
      lazy
      :fullscreen="isMobile"
    >
      <workplaces-form
        :close-me="closeDialog"
        :workplaceData="selectedWorkplace"
        :key="(selectedWorkplace || {})._id"
      />
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
import WorkplacesForm from './WorkplacesForm'
import { mapGetters, mapActions } from 'vuex'
import SlotDial from '@/components/SlotDial'

export default {
  components: {
    SlotDial,
    WorkplacesForm
  },
  data: function () {
    return {
      isFetching: false,
      dialog: false,
      selectedWorkplace: null,
      loading: true,
      pagination: {
        sortBy: 'name'
      },
      selected: []
    }
  },
  computed: {
    ...mapGetters(['workplaces', 'specialty']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    headers() {
      return [
        {
          text: 'Local',
          value: 'local'
        },
        {
          text: 'Area',
          value: 'area'
        }
      ]
    }
  },
  async created() {
    this.getWorkplaces().then(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions(['getWorkplaces', 'deleteWorkplaces']),
    deleteEntries() {
      this.loading = 'error'
      this.deleteWorkplaces(this.selected)
        .then(() => {
          this.$store.dispatch('showErrorSnackbar', 'Entries Deleted')
        })
        .catch(({ message = 'Something went wrong' }) => {
          this.$store.dispatch('showErrorSnackbar', message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeDialog() {
      this.dialog = false
      this.selectedWorkplace = null
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = (this.entries || []).slice()
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    editWorkplaces(selectedWorkplace) {
      this.selectedWorkplace = this.workplaces[selectedWorkplace.index]

      this.dialog = true
    }
  }
}
</script>

<style></style>
